export function onNewVersion(previousAppVersion: string, appVersion: string, alertMessage: string) {
  console.warn(`App version changed from ${previousAppVersion} to ${appVersion}. Reloading page...`)
  window.alert(alertMessage)
  window.location.reload()
}
